export const ADD_POST_DATA = "ADD_POST_DATA";
export const NO_CONTENT_AVAILABLE = "NO_CONTENT_AVAILABLE";
export const ADD_QUESION_DATA = "ADD_QUESION_DATA";
export const DELETE_QUESION_DATA = "DELETE_QUESION_DATA";
export const ADD_SAVED_DATA = "ADD_SAVED_DATA";
export const ADD_ALL_POST_DATA = "ADD_ALL_POST_DATA";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
export const DELETE_POST_DATA = "DELETE_POST_DATA";
export const ADD_POST_FILTERS = "ADD_POST_FILTERS";
export const ADD_SORT_BY = "ADD_SORT_BY";
export const ALL_BRANDS = "ALL_BRANDS";